<!--系统管理-用户管理列表-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-card class="all-card-style " >

      <!--      搜索模块-->
      <div class="search-box">
        <a-form layout="inline" >

          <a-form-item
            label="内容"  class ='ant-form-item2'
          >
            <a-input
              placeholder="请输入" v-model="queryInfo.keyword"
            >
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="getUsers" >
              查询
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--      列表表格-->
      <div>
        <a-button type="primary" html-type="submit" @click="toAddPage">
          添加
        </a-button>
        <a-table :pagination="pagination" @change="handleTableChange" :columns="columns" :data-source="data" >
          <span slot="action" slot-scope="text, record">
            <a @click="toEditPage(record)">修改</a>
            <a-divider type="vertical"/>
            <a @click="showDeleteModal(record)">删除</a>
          </span>
        </a-table>
      </div>
    </a-card>
    <!--              弹出框-->
    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleDelete" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal>

  </div>
</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'





  export default {
    name: 'userList',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1:"系统管理",
        titleMsg2:'用户管理',
        titleMsg3:'用户管理',
        data:[],
        user:{},
        roleSelectItems:[],
        columns:[
          {
            title: '编号',
            dataIndex: 'ID',
            key: 'ID',
          },
          {
            title: '用户名称',
            dataIndex: 'cUserName',
            key: 'cUserName',
          },
          {
            title: '性别',
            dataIndex: 'cSex',
            key: 'cSex',
          },
          {
            title: '创建时间',
            dataIndex: 'dCreateDate',
            key: 'dCreateDate',
          },
          {
            title: '角色',
            dataIndex: 'cRoleName',
            key: 'cRoleName',
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
          },

        ],
        deleteModalVisible:false,
        queryInfo:{

          keyword:"",
          page:1,
          limit:10,
          cSystemCode:'节水灌溉'
        },
        pagination: {
          current:1,
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
        },
      }
    },
    mounted () {
      this.getUsers();
    },
    methods:{

      toAddPage(){
        let that=this;
        this.$router.push({path:'/systemManagement/user/userForm'});

      },
  toEditPage(record){
      let that=this;
      that.user=record;

     that.$router.push({name:'UserForm',params:{user:that.user}});
  },
      showDeleteModal:function (record) {
        this.user=record;
        this.deleteModalVisible=true
      },
      handleTableChange(pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.queryInfo.page = pagination.current;
        this.queryInfo.limit = pagination.pageSize;
        this.getUsers();
      },
      async getUsers(){
        var _this=this
        _this.queryInfo.cEntID=_this.$store.getters.User.enterprise.ID;
        let res=await _this.$http.post('User/PageList',_this.queryInfo)

        if(res.data.code ==200){
          _this.data=res.data.obj.list
          _this.pagination.total=res.data.obj.listTotal

        }
        else{

        }
      },

      async handleDelete(){
        let that=this;
        let param=null;
        let res=await that.$http.post('User/Delete?ids='+that.user.ID,param)


        if(res.data.code=="200"){
          this.deleteModalVisible=false;
          that.$message.success(res.data.message)
          that.getUsers();
        }
        else{
          that.$message.error(res.message)

        }
      },
      handleOk:function () {
        // this.$router.push('/')
        this.deleteModalVisible=false
      },
    }
  }
</script>
